<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-zhihuidiaodu`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_a619d39cd8__clip0_1284_72363)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3ZM1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9ZM10.3669 7.63922L8.50553 8.50784L7.63691 10.3692L9.49824 9.50055L10.3669 7.63922ZM11.4146 5.49496C12.1128 5.16914 12.8369 5.89326 12.5111 6.59144L10.6269 10.6292L6.58914 12.5134C5.89095 12.8392 5.16684 12.1151 5.49266 11.4169L7.37692 7.37923L11.4146 5.49496Z"/></g><defs><clipPath id="svg_a619d39cd8__clip0_1284_72363"><path d="M0 0H18V18H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconZhihuidiaodu',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
